/**
 * The 16 modules of the permission matrix, and the 6 seeded roles.
 *
 * `ModuleKey` mirrors the Prisma `ModuleKey` enum exactly. Adding a module is a
 * code change either way (routes + guard target + screen), so the DB enum buys
 * referential integrity for free. `RoleKey` is deliberately NOT a DB enum —
 * `Role.key` is a unique string so a user-created role later ("Senior Sales")
 * is a data change, not a migration.
 */
export const MODULE_KEYS = [
    'DASHBOARD',
    'LEAD_CRM',
    'CUSTOMER_CRM',
    'TOUR_MASTER',
    'BOOKING_MANAGEMENT',
    'INVOICE_GENERATOR',
    'BOOKING_VOUCHER',
    /**
     * Added when the Credit Notes screen was built. It had been rendering as a
     * visibly-disabled nav item precisely because it had no key to be guarded by
     * — see `PENDING_NAV` in the frontend's module registry.
     */
    'CREDIT_NOTES',
    'PAYMENTS_RECEIPTS',
    'HOTEL_VENDOR_MANAGEMENT',
    'VEHICLE_MANAGEMENT',
    'EXPENSE_TRACKING',
    'REPORTS_ANALYTICS',
    'NOTIFICATIONS',
    'SETTINGS_ROLES',
    /**
     * Public-website management (images, tour web content, later video and
     * places). Owner grants it to whichever role should run the site;
     * everyone else starts at NONE — see `DEFAULT_PERMISSION_MATRIX`.
     */
    'WEBSITE',
];
export const MODULE_KEY = Object.freeze(Object.fromEntries(MODULE_KEYS.map((m) => [m, m])));
export function isModuleKey(value) {
    return typeof value === 'string' && MODULE_KEYS.includes(value);
}
/** Human labels for nav and the future Settings grid. */
export const MODULE_LABELS = Object.freeze({
    DASHBOARD: 'Dashboard',
    LEAD_CRM: 'Lead CRM',
    CUSTOMER_CRM: 'Customer CRM',
    TOUR_MASTER: 'Tour Master',
    BOOKING_MANAGEMENT: 'Booking Management',
    INVOICE_GENERATOR: 'Invoice Generator',
    BOOKING_VOUCHER: 'Booking Voucher',
    CREDIT_NOTES: 'Credit Notes',
    PAYMENTS_RECEIPTS: 'Payments & Receipts',
    HOTEL_VENDOR_MANAGEMENT: 'Hotel & Vendor Management',
    VEHICLE_MANAGEMENT: 'Vehicle Management',
    EXPENSE_TRACKING: 'Expense Tracking',
    REPORTS_ANALYTICS: 'Reports & Analytics',
    NOTIFICATIONS: 'Notifications',
    SETTINGS_ROLES: 'Settings / Roles & Permissions',
    WEBSITE: 'Website',
});
export const ROLE_KEYS = [
    'OWNER',
    'ADMIN',
    'SALES',
    'ACCOUNTS',
    'TOUR_MANAGER',
    'MARKETING',
];
export function isRoleKey(value) {
    return typeof value === 'string' && ROLE_KEYS.includes(value);
}
export const ROLE_LABELS = Object.freeze({
    OWNER: 'Owner',
    ADMIN: 'Admin',
    SALES: 'Sales',
    ACCOUNTS: 'Accounts',
    TOUR_MANAGER: 'Tour Manager',
    MARKETING: 'Marketing',
});
//# sourceMappingURL=modules.js.map